import Link from 'next/link';
import { Icon } from '../Icon';

export interface CategoryItem {
  name: string;
  slug: string | null;
}

export interface VBCCategoriesProps {
  categories: CategoryItem[];
  basePath?: string;
}

/**
 * Category tags linking to the filtered vendors listing
 * (`/vendors?category=<name>`), matching the homepage category-tile behavior.
 * Server Component.
 */
export function VBCCategories({ categories, basePath = '' }: VBCCategoriesProps) {
  if (categories.length === 0) return null;

  return (
    <section
      className="mb-10 rounded-xl border p-6"
      style={{
        borderColor: 'var(--brand-card-border)',
        boxShadow: 'var(--shadow-resting)',
        backgroundColor: 'var(--brand-card-bg)',
      }}
    >
      <h2
        className="overline mb-4"
        style={{ color: 'var(--brand-primary, #014F8A)' }}
      >
        Categories
      </h2>
      <div className="flex flex-wrap gap-2">
        {categories.map((cat) => (
          <Link
            key={cat.name}
            href={`${basePath}/vendors?category=${encodeURIComponent(cat.name)}`}
            className="focus-luxury inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 font-medium transition-all duration-200 hover:bg-[rgba(1,79,138,0.06)]"
            style={{
              borderColor: 'var(--brand-primary, #014F8A)',
              color: 'var(--brand-primary, #014F8A)',
              fontSize: '13px',
              letterSpacing: '0.01em',
            }}
          >
            <Icon name="sell" size={12} />
            {cat.name}
          </Link>
        ))}
      </div>
    </section>
  );
}
